import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { CmsComponentSwitch } from 'src/cms/CmsComponentSwitch';
import { Box } from 'src/components-v2/Layout';
import { AEO_MARKDOWN_ENTRY_ATTRIBUTE } from 'src/lib/aeo-markdown';
import type { Entry, Sys } from 'src/types/contentful-sdk-compat';

type HideFromAeoFields = {
  components?: Entry[];
};

type HideFromAeoProps = {
  fields?: HideFromAeoFields;
  sys?: Sys;
};

export const HideFromAeo = ({
  fields,
  sys,
  ...componentSwitchProps
}: HideFromAeoProps) => {
  const inspectorProps = useContentfulInspectorMode({
    entryId: sys?.id,
  });

  return (
    <Box
      className='cms-hide-from-aeo hide-for-aeo'
      {...inspectorProps({ fieldId: 'components' })}
    >
      <CmsComponentSwitch
        {...componentSwitchProps}
        components={fields?.components}
      />
    </Box>
  );
};

type AeoMarkdownProps = {
  sys?: Sys;
};

export const AeoMarkdown = ({ sys }: AeoMarkdownProps) => {
  if (!sys?.id) {
    return null;
  }

  // The markdown body intentionally never reaches the browser. The compiler
  // and /api/aeo replace this marker with the Contentful body.
  //
  // The `AEO:` text is load-bearing: Turndown skips nodes with no text
  // content, so a marker carrying only the data attribute would never reach
  // the replacement rule.
  return (
    <Box
      className='cms-aeo-markdown'
      hidden
      aria-hidden='true'
      {...{ [AEO_MARKDOWN_ENTRY_ATTRIBUTE]: sys.id }}
    >
      {`AEO:${sys.id}`}
    </Box>
  );
};
